export default __webpack_public_path__ + "static/mars-banner-72600f10ee798ffd734da99d8e194352.jpg";